export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        teams: action.teams,
      };

    case 'SELECT':
      return {
        ...state,
        selectedTeam: action.team,
      };

    case 'CREATE':
      return {
        ...state,
        teams: [...state.teams, action.team],
      };

    case 'UPDATE':
      return {
        ...state,
        teams: state.teams.map(
          (team) => (team.id === action.team.id ? action.team : team),
        ),
      };

    case 'DESTROY':
      return {
        ...state,
        teams: state.teams.filter(
          (team) => team.id !== action.team.id,
        ),
      };

    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
